<template>
  <v-dialog v-model="dialog" persistent scrollable max-width="990px">
    <div class="bg-white poppins" style="background-color: white; height: 100%">
      <div class="modal-header py-4 align-center">
        <h4 class="mb-0 font-weight-bolder">
          {{ item ? "Edit" : "Add" }} new service
        </h4>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <!--        <v-btn rounded color="primary" @click="dialog = false">-->
        <!--          Create-->
        <!--        </v-btn>-->
      </div>
      <v-card-text class="pt-2 h-100">
        <v-stepper v-model="step" flat>
          <v-stepper-header>
            <v-stepper-step :complete="step > 1" step="1">
              Select service
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="step > 2" step="2">
              Service form
            </v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card elevation="0" class="mb-4">
                <form id="editForm" class="pa-3 pt-4 pb-0 row">
                  <div class="col-12">
                    <v-autocomplete
                      v-model="formData.id"
                      label="Service"
                      item-text="text"
                      item-value="index"
                      clearable
                      outlined
                      :items="services"
                      hide-selected
                      :error-messages="idErrors"
                      @input="$v.formData.id.$touch()"
                      @blur="$v.formData.id.$touch()"
                    ></v-autocomplete>
                  </div>

                  <v-main class="text-center mt-4">
                    <v-btn color="primary" @click="handleStage1">
                      {{ item ? "Continue" : "Add" }}
                    </v-btn>
                  </v-main>
                </form>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-4 ma-0 pa-0" elevation="0" v-if="isStep2Ready">
                <component
                  ref="step2Form"
                  v-bind:is="step2FormComponent"
                  :setData="setForm2Data"
                  :actionFuntion="handleStage2"
                  :serverData="serverData"
                  :pageLoader="pageLoader"
                  :initData="true"
                ></component>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
    </div>
  </v-dialog>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
// import Swal from "sweetalert2";

import DeliveryForm from "@/own/components/finance/services/addForms/DeliveryForm.vue";
import FulfillmentForm from "@/own/components/finance/services/addForms/FulfillmentForm";
import StorageForm from "@/own/components/finance/services/addForms/StorageForm";
import FulfillmentDelivery from "@/own/components/finance/services/addForms/FulfillmentDeliveryForm.vue";
import ApiService from "@/core/services/api.service";
import AdditionalForm from "@/own/components/finance/services/addForms/AdditionalForm.vue";
import StockCollectionForm from "@/own/components/finance/services/addForms/StockCollectionForm.vue";
import ReturnsAndImportDeliveryForm from "@/own/components/finance/services/addForms/ReturnsAndImportDeliveryForm.vue";

export default {
  name: "EditSku",
  mixins: [validationMixin],
  validations: {
    formData: {
      id: { required },
    },
  },
  props: ["item", "actionFunction", "services", "pageLoader", "contract"],
  data: () => ({
    dialog: false,
    step2Form: null,
    step: 1,
    serverData: null,
    formData: {
      id: null,
      values: null,
    },
    formObject: {
      2: StorageForm,
      3: DeliveryForm,
      1: FulfillmentForm,
      4: FulfillmentDelivery,
      7: AdditionalForm,
      8: StockCollectionForm,
      9: ReturnsAndImportDeliveryForm,
    },
    old_item_id: null,
  }),
  methods: {
    handleStage1() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        this.loadDataFromServer();
        if (!this.item) {
          this.$nextTick(() => {
            this.handleStage2();
          });
        }
      }
    },
    handleStage2(action = "submit") {
      if (action == "submit") {
        this.submitEditForm();
      } else {
        this.step = 1;
      }
    },
    setForm2Data(item) {
      // console.log("before ap", this.formData.clients);
      let copy = { ...this.formData };
      copy.values = item;
      this.formData = copy;
      // console.log("after ap", this.formData.clients);
    },
    setStep2Form() {
      this.step2Form =
        this.formObject[this.serverData.service.values.service_type_id];

      this.$nextTick(function () {
        this.$refs.step2Form.resetCreateForm();
      });
      if (this.isStep2Ready) {
        this.step = 2;
      }
      this.pageLoader(false);
    },
    loadDataFromServer() {
      this.step2Form = null;
      this.pageLoader(true);
      let data = { service_id: this.formData.id, contract_id: this.contract };
      // console.log(data, this.formData);
      ApiService.post("/cod/contracts/services", data)
        .then((response) => {
          this.serverData = response.data;
          this.serverData.service = { values: response.data.values };
          this.setStep2Form();
        })
        .catch(() => {
          this.step = 1;
        });
    },
    handleFormValidation(fieldName, vueObj) {
      let errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      return errors;
    },
    submitEditForm() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        // this.formData.system_code = this.items.map(sku =>
        //   sku.skuId == this.formData.sku_id ? sku.systemCode : null
        // )[0];
        // console.log("supermode is ", this.formData, this.items);
        this.actionFunction(this.formData, this.old_item_id);
        this.toggleModal();
        this.pageLoader(false);
      }
    },
    resetFormData() {
      this.$v.$reset();
      this.step = 1;
      if (this.item) {
        this.formData = JSON.parse(JSON.stringify(this.item));
        this.old_item_id = this.item.id;
      } else {
        this.formData = {
          id: null,
          values: null,
        };
        this.old_item_id = null;
      }
    },
    toggleModal() {
      this.serverData = null;
      this.old_item_id = null;
      this.resetFormData();
      this.dialog = !this.dialog;
    },
  },
  computed: {
    idErrors: function () {
      return this.handleFormValidation("id", this);
    },
    step2FormComponent: function () {
      return this.step2Form;
    },
    isStep2Ready: function () {
      return !!this.serverData;
    },
  },
};
</script>
